import { useMemo } from 'react';

import { InputGroupV2, UniversalSelect } from '@equip.health/ui';

import { dropdownMenuOptionsMapper } from '~/lib/util/inquiry.util';

import { DropdownMultiSelectProps } from './types';
import { useGetProviderPronounsEnumQuery } from '~/store/services/enumerations';
import { getMultiSelectedUniversalSelectOptions } from '~/lib/util/profile.util';

const PronounsDropdown = ({
  id,
  onSelectValues,
  values,
}: DropdownMultiSelectProps) => {
  const { data: pronouns } = useGetProviderPronounsEnumQuery();
  const pronounOptions = useMemo<UniversalSelectOption[]>(() => {
    return dropdownMenuOptionsMapper((pronouns || []).map((x) => x.label));
  }, [pronouns]);

  return (
    <InputGroupV2
      id={`${id}__pronoun`}
      isRequired={false}
      label="Pronouns on record"
    >
      <UniversalSelect
        id={`${id}__pronoun`}
        isSearchable
        isSingleSelect={false}
        onChange={(selected: UniversalSelectOption[]) =>
          onSelectValues(selected.map((option) => option.value))
        }
        options={pronounOptions}
        value={getMultiSelectedUniversalSelectOptions(values, pronounOptions)}
      />
    </InputGroupV2>
  );
};

export default PronounsDropdown;
